module.exports = __webpack_public_path__ + "img/thumbnail_YellowAnaconda_u_normal.f1d40455.png";